<template>
    <div id="mainMenu">
        <nav class="navbar navbar-expand fixed-top navbar-dark bg-dark top-nav">
            <div class="container">
                <router-link :to="linkTo" class="navbar-brand mr-auto mr-lg-0">
                    <slot name="brand">TITAN</slot>
                </router-link>
                <button class="navbar-toggler p-0 border-0" type="button" data-toggle="offcanvas"
                        v-on:click="openedCollapse = !openedCollapse">
                    <span class="navbar-toggler-icon"></span>
                </button>
                <div class="navbar-collapse" :class="{'open': openedCollapse}">
                    <div class="user ml-auto">
                        <slot name="navbar"></slot>
                    </div>
                </div>
            </div>
        </nav>
        <div class="nav-scroller bg-white secondary-nav">
            <div class="container">
                <nav class="nav nav-underline">
                    <ul class="nav-main">
                        <li v-for="(link, index) in links" :key="'mainMenu-'+index">
                            <router-link :to="link.route"
                                         :target="getTarget(link)"
                                         class="nav-link"
                                         :class="{'active': link.route.name === $route.name}"
                                         v-if="isVisible(link) && link.route !== undefined"
                            >
                                {{ link.name }}
                                <div class="badge badge-success" v-if="link.new !== undefined && link.new === true">
                                    {{t('New')}}
                                </div>
                            </router-link>
                            <a :href="link.link"
                               :target="getTarget(link)"
                               class="nav-link"
                               v-if="isVisible(link) && link.link !== undefined"
                            >
                                {{ link.name }}
                                <div class="badge badge-success" v-if="link.new !== undefined && link.new === true">
                                    {{t('New')}}
                                </div>
                            </a>
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
    </div>
</template>
<script>
    import LocaleChanger from '../../core/Translator/locale-switcher'

    export default {
        components: {
            LocaleChanger
        },
        props: {
            links: {
                type: Array,
                required: true
            },
            linkTo: {
                type: Object,
                default: () => {
                    return {name: 'dashboard'};
                }
            }
        },
        methods: {
            isVisible(item) {
                const visible = item.visible === undefined ? true : item.visible;
                return typeof visible === 'function' ? visible(item) : visible;
            },
            getTarget(item) {
                return item.target === undefined ? '_self' : item.target;
            }
        },
        data() {
            return {
                openedCollapse: false,
            };
        }
    }
</script>

<style lang="scss">
    #mainMenu {
        > .navbar > .container {
            padding-left: 15px;
            padding-right: 15px;
        }

        .fixed-top {
            padding-left: 0;
            padding-right: 0;
        }

        .top-nav {
            .navbar-brand {
                font-weight: bold;
                padding-right: 25px;
            }

            .nav-link {
                font-weight: 600;
                font-size: 16px;
                padding-left: 20px;
                padding-right: 20px;

                &:first-child {
                    padding-left: 0;
                }
            }
        }

        .nav-scroller {
            position: relative;
            z-index: 2;
            border-bottom: 2px solid #e3e6ea;
            overflow-y: hidden;
            overflow-x: inherit;

            ul.nav-main {
                margin: 0;
                padding: 0;
                list-style: none;

                > li {
                    display: inline-block;
                    position: relative;

                    > ul {
                        position: absolute;
                        background: #000;
                    }

                }

                > li:first-child > a {
                    padding-left: 0;
                }
            }

            .nav {
                display: -ms-flexbox;
                display: flex;
                -ms-flex-wrap: nowrap;
                flex-wrap: nowrap;
                /*padding-bottom: 1rem;*/
                margin-top: -1px;
                color: rgba(255, 255, 255, .75);
                text-align: center;
                white-space: nowrap;
                -webkit-overflow-scrolling: touch;
                padding-bottom: 0;

                .nav-link {
                    padding-top: 13px;
                    padding-bottom: 13px;
                    font-size: 16px;
                    color: #000;

                    &:hover,
                    &.active {
                        color: #009DFA;
                    }

                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/admin/Layout/TheMainMenu.vue